import React from 'react';
import PropTypes from 'prop-types';

import sAction from 'sAction';

export default function Button(props) {
    const className = 'newListViewLine ' + props.extraClass;

    const params = JSON.parse(JSON.stringify(props.params || {}));
    for (const key in params) {
        if (!Object.prototype.hasOwnProperty.call(params, key)) continue;

        if (params[key] === '{value}') {
            params[key] = props.value;
        }
    }

    return <div className={className + ' fileDownloadField'}>
        <div onClick={() => {
            props.function(params);
        }}
        className={'listBtn ' + props.class}>
            <span className={'icon-' + props.icon} />
            {sAction.translate(props.label, props.module)}
        </div>
    </div>;
}

Button.propTypes = {
    value: PropTypes.string,
    module: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    function: PropTypes.func.isRequired,
    params: PropTypes.object,
    extraClass: PropTypes.string,
    class: PropTypes.string,
};
